import script from "./GmxTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxTable.vue?vue&type=script&setup=true&lang=js"

import "./GmxTable.vue?vue&type=style&index=0&id=faad2680&scoped=true&lang=scss"
import "./GmxTable.vue?vue&type=style&index=1&id=faad2680&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faad2680"]])

export default __exports__